module.exports = __webpack_public_path__ + "static/media/MajooCRM13.31d89b60.png";